export default "__VITE_ASSET__CkMLCXyL__"